import { render, staticRenderFns } from "./Footerbar.vue?vue&type=template&id=1d619560&scoped=true&"
import script from "./Footerbar.vue?vue&type=script&lang=js&"
export * from "./Footerbar.vue?vue&type=script&lang=js&"
import style0 from "./Footerbar.vue?vue&type=style&index=0&id=1d619560&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.5_babel-core@7.0.0-bridge.0_cache-loader@4.1.0_css-loader@3.6.0_vue-template-_ar323sprjn4ukbaqn3gh4itclu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d619560",
  null
  
)

export default component.exports